function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f962b690-d254-48bb-a452-aee317b90005{isolation:isolate;}.e93a9287-566b-4a09-b5ec-971b8a1b4f58{fill:#fff;}.a2d8d74e-01d0-42c6-8a97-928e2fb0c149{fill:url(#e46d3ce7-fe86-4544-9441-63ab9ea9572f);}.b43d0ae9-210c-4c2a-817c-13dcd49194e2{fill:url(#b08790ab-ed7e-4379-bb1d-06fc6f333102);}.aa260fea-14ec-4110-b0d4-f01cf01e4d3f{fill:url(#a812bf75-9419-4460-8e4c-8d49ad285f59);}.a8e85472-d2fb-4d16-ad9d-17313962a6ff{mix-blend-mode:multiply;fill:url(#ff7b62b3-41ff-4696-96a7-68d86799832f);}.b342568a-8ea0-496d-a0d9-91323c53e732{fill:#ffb700;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e46d3ce7-fe86-4544-9441-63ab9ea9572f",
  x1: -139.21,
  y1: 46.37,
  x2: -139.58,
  y2: 47.21,
  gradientTransform: "translate(29077.62 -15946.26) scale(207.62 345.14)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffca05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#ffca05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#fbc008"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#f1a60f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#e07b1b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#de771c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b08790ab-ed7e-4379-bb1d-06fc6f333102",
  x1: -139.25,
  y1: 46.29,
  x2: -139.57,
  y2: 47.16,
  gradientTransform: "translate(31115.34 -16876.74) scale(222.04 366.29)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ec1c24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#e31c23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#cb1c22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a61c20"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a812bf75-9419-4460-8e4c-8d49ad285f59",
  x1: -139.2,
  y1: 46.56,
  x2: -139.61,
  y2: 47.3,
  gradientTransform: "translate(36309.59 -16015.74) scale(258.83 348.15)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00adee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#049fdc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#0f7aac"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#20405f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#24344f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ff7b62b3-41ff-4696-96a7-68d86799832f",
  x1: -139.31,
  y1: 47.2,
  x2: -139,
  y2: 47.6,
  gradientTransform: "translate(21019.24 -9474.85) scale(149.1 205.28)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#808184"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#858689",
  stopOpacity: 0.88
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#8e9093",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#919396",
  stopOpacity: 0
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "SAS APP ICON NEW");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "f962b690-d254-48bb-a452-aee317b90005"
}, /*#__PURE__*/React.createElement("g", {
  id: "a344ea53-fc17-4027-abde-affe93f0518b",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "a92c509c-feee-47a4-ab68-dc0a5e704fd2",
  "data-name": "APP-STORE-Assets"
}, /*#__PURE__*/React.createElement("g", {
  id: "acbf0e9a-3b59-49bc-86a3-06f184549f37",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("g", {
  id: "ff832ee1-4a79-4f83-8709-3b8738c049a5",
  "data-name": "SAS-APP-Icon"
}, /*#__PURE__*/React.createElement("rect", {
  id: "face8d6c-1355-4bc2-b178-8835b454c03b",
  "data-name": "Background",
  className: "e93a9287-566b-4a09-b5ec-971b8a1b4f58"
}), /*#__PURE__*/React.createElement("g", {
  id: "b33853b6-3c69-4ed2-a512-70e6cac67599",
  "data-name": "SAS-icon MASTEREDIT-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "e02c2747-d7a9-4f9c-81c0-6d071cf866f2",
  "data-name": "SAS-icon MASTEREDIT"
}, /*#__PURE__*/React.createElement("g", {
  id: "afae29f4-67d3-4fe3-8788-74ea544b4942",
  "data-name": "Layer 4"
}, /*#__PURE__*/React.createElement("path", {
  id: "b1186726-a197-48f9-ab15-ae8e3daea38a",
  "data-name": "Shape",
  className: "e93a9287-566b-4a09-b5ec-971b8a1b4f58",
  d: "M191.83,477.28h-.3a163.61,163.61,0,0,1-73.3-18.9,170.72,170.72,0,0,1-64-58.9,174.93,174.93,0,0,1-27.5-94.6,161.71,161.71,0,0,1,4.4-39.3c12.1-47.9,44.9-91.9,79.5-138.5,36.3-49,72.2-90.4,72.6-90.8l4.7-5.4h93.5l-20.2,25.9c-1.5,1.9-3.3,4.2-5.2,6.5h55.1l-20.8,25.5c-.7.9-3.8,4.6-8,9.7h57l-21.4,25.6c-.1.2-10.3,12.4-21.5,26.3,27.4,37.7,52,75.1,62.2,115.1a152.71,152.71,0,0,1,4.4,37.6c0,26-4.9,50.6-14.7,72.9a165,165,0,0,1-38.9,55,173.28,173.28,0,0,1-117.6,46.3Zm3.1-199.6c-5.5,7-12.4,15.9-19.4,25.5l-.3.4c-14.6,20.1-32.6,45-32.6,70.8,0,39.5,27.1,53.5,52.4,53.5s52.5-21.8,52.5-57.1c0-11.8-2.4-26.6-31.9-66.1-.4-.5-.8-1.1-1.2-1.7-2.8-3.8-5.8-7.8-8.9-12C201.43,286,197.73,281.28,194.93,277.68Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "a35f0b33-1219-45ab-9323-3e8d23f8570a",
  "data-name": "Layer 8"
}, /*#__PURE__*/React.createElement("g", {
  id: "a6ebfe3e-8a33-48cc-b64f-217225fe5050",
  "data-name": "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "fa2a555a-ac6b-4716-9377-8841ad2701b2",
  "data-name": "Path",
  className: "a2d8d74e-01d0-42c6-8a97-928e2fb0c149",
  d: "M91.52,254.33c24.1-39.3,63.6-89.2,74.9-103.7,1.5-2,2.7-3.4,3.2-4.2,9.2-12.1,23-29.2,37.6-47.3,6.1-7.6,10.8-13.4,16.8-20.8,8.1-10,25.9-32.5,25.9-32.5h-54.7s-35.5,40.8-72,90c-34.2,46.1-65.6,88.6-77,133.3-2.9,11.3-3.9,23.3-3.9,35.5a160.12,160.12,0,0,0,25.1,86.3C38.42,343.13,76.22,279.43,91.52,254.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b43d0ae9-210c-4c2a-817c-13dcd49194e2",
  d: "M90.72,350.93c3-17.9,13-40.2,23.9-58.4,8.6-14.2,28.8-43.8,84.2-115.4l1.6-2.1c9.1-11.8,25.7-31.7,49.9-61.4h0c11.8-15.1,28.4-35.3,28.4-35.3h-54.8c-5.9,7.4-10.6,13.2-16.8,20.8-14.6,18.1-28.4,35.2-37.6,47.3-.6.8-1.7,2.2-3.2,4.2-11.3,14.5-50.8,64.4-74.9,103.7-15.3,25-53.1,88.8-24.1,136.5a154.24,154.24,0,0,0,58.3,53.7C98.52,429.53,84.52,388.53,90.72,350.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "aa260fea-14ec-4110-b0d4-f01cf01e4d3f",
  d: "M192.12,461.73c78.1,0,156-59.5,156-158.8a134.83,134.83,0,0,0-3.9-33.8c-10.2-40.2-36.6-78.6-66.7-119.5,13.8-17.7,29.1-36.1,29.1-36.1h-56.2c-24.2,29.8-40.8,49.5-49.9,61.4l-1.6,2.1c-55.5,71.8-75.7,101.2-84.3,115.5-10.9,18.1-20.9,40.5-23.9,58.4-6.2,37.6,7.7,78.6,35,93.7a149.37,149.37,0,0,0,66.4,17.1h0m-64.9-87.5c0-31.1,20.7-59.5,36-80.6,13.6-18.8,26.9-34.8,30.9-39.6a15.37,15.37,0,0,0,1.2-1.5s4.7,5.6,11.7,14.3c3.3,4.2,7.2,9.1,11.3,14.5,3,3.9,6,8,9.1,12.3.4.5.7,1,1.1,1.5,30.8,41.3,35,59.2,35,75.5,0,34.9-26,72.8-68.2,72.8C150.72,443.53,127.22,412,127.22,374.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a8e85472-d2fb-4d16-ad9d-17313962a6ff",
  d: "M344.42,269.83c-.1-.2-.1-.5-.2-.7-10.2-40.2-36.6-78.6-66.7-119.4h0c-25.8,32.1-57.9,72.2-82.2,102.9h0s4.7,5.6,11.7,14.3c3.3,4.2,7.2,9.1,11.3,14.5,3,3.9,6,8,9.1,12.3.4.5.7,1,1.1,1.5,21.5,28.9,30,46.4,33.2,59.8Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "eb1c4b41-5a1e-4bce-8e56-47c1929db09c",
  "data-name": "Layer 6"
}, /*#__PURE__*/React.createElement("path", {
  className: "b342568a-8ea0-496d-a0d9-91323c53e732",
  d: "M204.08,452.44a17.35,17.35,0,0,1-15-26L305,225.84a17.28,17.28,0,0,1,30,0l115.8,200.6a17.35,17.35,0,0,1-15,26Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M320,224.94a9.45,9.45,0,0,1,8.3,4.8l115.8,200.6a9.55,9.55,0,0,1-8.3,14.3H204.08a9.54,9.54,0,0,1-8.3-4.8,9.35,9.35,0,0,1,0-9.5l115.9-200.6a9.45,9.45,0,0,1,8.3-4.8m0-15.5a24.7,24.7,0,0,0-21.7,12.6l-115.9,200.5a25.1,25.1,0,0,0,21.7,37.7h231.6a25.1,25.1,0,0,0,21.7-37.7l-115.7-200.6a24.92,24.92,0,0,0-21.7-12.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e93a9287-566b-4a09-b5ec-971b8a1b4f58",
  d: "M320,209.35a24.7,24.7,0,0,1,21.7,12.6l115.8,200.6a25.12,25.12,0,0,1-21.7,37.7H204.09a25.1,25.1,0,0,1-21.7-37.7L298.19,222a25.06,25.06,0,0,1,21.8-12.6m0-15.5a41.38,41.38,0,0,0-19.8,5.1,39.72,39.72,0,0,0-15.4,15.3l-115.9,200.5a41,41,0,0,0-5.5,21,40.31,40.31,0,0,0,5.5,19.7,40.84,40.84,0,0,0,14.3,14.6,41.36,41.36,0,0,0,20.9,5.8h231.6a40.9,40.9,0,0,0,40.7-40.1,41,41,0,0,0-5.5-21l-115.7-200.6a41.12,41.12,0,0,0-15.4-15.3,41.58,41.58,0,0,0-19.8-5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334,401.85a13.67,13.67,0,0,1-4.3,10.3,14.61,14.61,0,0,1-20.5,0,13.67,13.67,0,0,1-4.3-10.3,14.34,14.34,0,0,1,4.2-10.4,13.67,13.67,0,0,1,10.3-4.3,14,14,0,0,1,10.3,4.2A14.26,14.26,0,0,1,334,401.85Zm-2.2-103.5c0,1.9-.1,3.6-.2,5.2s-.4,4-.7,7.3l-7.2,60.6h-8.3l-7.2-60.6a124.07,124.07,0,0,1-.9-12.5c0-4.7,1.2-8.2,3.7-10.4a12.4,12.4,0,0,1,8.4-3.3,12.22,12.22,0,0,1,8.9,3.4C330.59,290.25,331.79,293.65,331.79,298.35Z"
})))))))));

var SvgSasApp = function SvgSasApp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SASAPPLOGO",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSasApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SAS-APP.5d7faecd.svg";
export { ForwardRef as ReactComponent };